import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { defineMessage } from "react-intl";

/**
 * @typedef {object} Partner
 * @property {import("react-intl").MessageDescriptor} label
 * @property {string} src
 */

/** @type {Partner[]} */
export const PARTNERS = [
  {
    label: defineMessage({ defaultMessage: "Village fleuri" }),
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: {
        filePath: "partners/village-fleuri.jpg",
      },
      includeBasePath: true,
    }),
  },
  {
    label: defineMessage({ defaultMessage: "Famille plus" }),
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: {
        filePath: "partners/famille-plus.jpg",
      },
      includeBasePath: true,
    }),
  },
  {
    label: defineMessage({ defaultMessage: "Ma commune a du coeur" }),
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: {
        filePath: "partners/ma-commune.jpg",
      },
      includeBasePath: true,
    }),
  },
  {
    label: defineMessage({ defaultMessage: "La Bresse hautes Vosges" }),
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: {
        filePath: "partners/ot-labresse.jpg",
      },
      includeBasePath: true,
    }),
  },
  {
    label: defineMessage({ defaultMessage: "Communauté de communes" }),
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: {
        filePath: "partners/com-com.jpg",
      },
      includeBasePath: true,
    }),
  },
  {
    label: defineMessage({ defaultMessage: "Hautes Vosges" }),
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: {
        filePath: "partners/hautes-vosges.jpg",
      },
      includeBasePath: true,
    }),
  },
  {
    label: defineMessage({ defaultMessage: "Ville sportive" }),
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: {
        filePath: "partners/ville-sportive.jpg",
      },
      includeBasePath: true,
    }),
  },
  {
    label: defineMessage({ defaultMessage: "Département Vosges" }),
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: {
        filePath: "partners/departement-vosges.jpg",
      },
      includeBasePath: true,
    }),
  },
  {
    label: defineMessage({ defaultMessage: "Région Grand Est" }),
    src: generateFrontPath({
      id: "@front.internal-assets",
      parameters: {
        filePath: "partners/region-grand-est.jpg",
      },
      includeBasePath: true,
    }),
  },
];
